// splide

const prElem = document.querySelector('.product-recommendations');

prElem.addEventListener('pr-loaded', (e) => {
	const splide = new Splide('#splide__product-recommendations', {
		type: 'loop',
		fixedWidth: '30rem',
		gap: '3.25rem',
		padding: {
			left: '26.8rem',
			right: 0
		},
		focus: 1,
		pagination: false,
		breakpoints: {
			767: {
				perPage: 1,
				fixedWidth : '100%',
				padding: {
					left: '2rem',
					right: '2rem'
				}
			},
			990: {
				perPage: 2,
				fixedWidth: '30rem',
				gap: '3.2rem',
				padding: {
					left: '6.7rem',
					right: 0
				}
			}
		}
	});
	
	splide.mount();

	const productCards = document.querySelectorAll("#splide__product-recommendations .product-card-wrapper");

	productCards.forEach((card) => {
		const mainLink = card.querySelector('.main-link');
		card.addEventListener('click', (ev) => {
			if ((ev.target.classList.contains('color-swatch')) || (ev.target.classList.contains('swatch-input'))) {
				return;
			}

			const isTextSelected = window.getSelection().toString();

			if (!isTextSelected) {
				mainLink.click();
			}
		});
	});
}, false);
